import {Component, OnInit, Inject, PLATFORM_ID} from '@angular/core';
import {REQUEST} from '@nguniversal/express-engine/tokens';
import {Request} from 'express';
import {isPlatformBrowser} from '@angular/common';
import {Meta} from '@angular/platform-browser';
import {SpecialRoutingService} from 'src/app/services/special-routing/special-routing.service';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';


@Component({
  selector: 'app-ssr',
  templateUrl: './ssr.component.html',
  styleUrls: ['./ssr.component.scss']
})
export class SsrComponent {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(REQUEST) private request: Request,
    private meta: Meta,
    private specialRoutingService: SpecialRoutingService,
    private http: HttpClient,
  ) {
  }

  isBrowser = false;
  query = this.request.query

  ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId);

    let view = this.request.route.path

    if (!this.isBrowser && view === '/profile/') {
      this.getProfileMetaTags()
      //this.addMetaTags(metatags);
    } else if (!this.isBrowser && view === '/shared/') {
      this.getChartMetaTags()
      //this.addMetaTags(metatags);
    }
    //const port = this.getPort();
    //const route = this.specialRoutingService.prepareRoute('landing');
    //this.specialRoutingService.redirectToRoute(route);

  }

  async getProfileMetaTags() {
    let url = `${environment.backend_base}main/retailer/metatags/`
    let payload = {profileId: this.query['id']}
    let urlMetatag = environment.frontend_base.slice(0, -1) + this.request.url


    let responseMetatagObject = ''
    await this.http.post(url, payload).subscribe((response: any) => {
      let metatags = response.metatag_object

      this.meta.updateTag({
        name: 'title',
        property: 'og:title',
        content: metatags.title,
      });
      this.meta.updateTag({
        name: 'description',
        property: 'og:description',
        content: metatags.description,
      });
      /*
      this.meta.updateTag({
        name: 'og:image',
        content: metatags.image,
      });*/
      this.meta.updateTag({
        name: 'url',
        property: 'og:url',
        content: urlMetatag,
      });
      this.meta.updateTag({
        property: 'twitter:title',
        content: metatags.title,
      });
      this.meta.updateTag({
        property: 'twitter:description',
        content: metatags.description,
      });
      /*
      this.meta.updateTag({
        property: 'twitter:image',
        content: metatags.image,
      });*/
      this.meta.updateTag({
        property: 'twitter:url',
        content: urlMetatag,
      });
    })
    return responseMetatagObject
  }

  async getChartMetaTags() {

    let url = `${environment.backend_base}main/visualizations/metatags/`
    let payload = {chartId: this.query['id']}

    let urlMetatag = environment.frontend_base.slice(0, -1) + this.request.url

    let responseMetatagObject = ''
    await this.http.post(url, payload).subscribe((response: any) => {
      let metatags = response.metatag_object

      this.meta.updateTag({
        name: 'title',
        property: 'og:title',
        content: metatags.title,
      });
      this.meta.updateTag({
        name: 'description',
        property: 'og:description',
        content: metatags.description,
      });

      this.meta.updateTag({
        name: 'image',
        property: 'og:image',
        content: metatags.image,
      });
      this.meta.updateTag({
        name: 'url',
        property: 'og:url',
        content: urlMetatag,
      });
      this.meta.updateTag({
        property: 'twitter:title',
        content: metatags.title,
      });
      this.meta.updateTag({
        property: 'twitter:description',
        content: metatags.description,
      });

      this.meta.updateTag({
        property: 'twitter:image',
        content: metatags.image,
      });
      this.meta.updateTag({
        property: 'twitter:url',
        content: urlMetatag,
      });

    })
    return responseMetatagObject
  }

}
